import { render, staticRenderFns } from "./common-service-grid.vue?vue&type=template&id=35fdfb60&scoped=true"
import script from "./common-service-grid.vue?vue&type=script&lang=js"
export * from "./common-service-grid.vue?vue&type=script&lang=js"
import style0 from "./common-service-grid.vue?vue&type=style&index=0&id=35fdfb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdfb60",
  null
  
)

export default component.exports